import React from "react";
import {render} from "react-dom";
import SiteGroupApp from "./components/App";

const appContainer = document.getElementById("sitegroups-container");

render(<SiteGroupApp/>, appContainer);
